module.exports = __webpack_public_path__ + "assets/autotest3.jpg?7db8539b885fdc00a35502fd9f397738";